var Vendd = (function (Vendd) {
	'use strict';

	Vendd.LazyProductList = (function (LazyProductList) {

	    LazyProductList.Messages = (function (Messages) {
			
            Messages.GetLazyProductList = function (serviceConfiguration, url) {
				var data = {
                    serviceConfiguration: serviceConfiguration,
                    url: url || ""
				};
				Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyProductList.Messages.GetLazyProductList", data);
			}
	        Messages.GetLazyProductList.className = "Vendd.LazyProductList.Messages.GetLazyProductList";

            Messages.LazyProductListSuccess = function (model, sender) {
				var data = {
                    model: model,
                    sender: sender
				};
				Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyProductList.Messages.LazyProductListSuccess", data);
			}
	        Messages.LazyProductListSuccess.className = "Vendd.LazyProductList.Messages.LazyProductListSuccess";

            Messages.LazyProductListFailure = function (model, sender) {
				var data = {
                    model: model,
                    sender: sender
				};
				Vendd.MessageBus.VenddMessage.call(this, "Vendd.LazyProductList.Messages.LazyProductListFailure", data);
			}
	        Messages.LazyProductListFailure.className = "Vendd.LazyProductList.Messages.LazyProductListFailure";

			
			return Messages;

	    })(LazyProductList.Messages || {});

	    return LazyProductList;

	})(Vendd.LazyProductList || {});

	return Vendd;

})(Vendd || {});
